import { mapGetters } from 'vuex'

export default {
    computed:
    {
        ...mapGetters({
            clients: 'clients'
        }),
    },
    watch:
    {
        '$route': 
        {
            handler()
            {
                this.setData()
            },
            immediate: true
        },
        isCreativeValid(value)
        {
            if (value) {
                this.validation()
            } else {
                this.item.is_valid = false
                this.menu[0].done = false
            }
        },
        isSettingsValid(value)
        {
            if (value) 
            {
                this.validation()
            } else {
                this.item.is_valid = false
                this.menu[1].done = false
            }
        },
    },
    methods:
    {
        setData()
        {
            this.slug = this.$route.params.item
            this.page = this.$route.params.slug
            this.fetch()
            this.validation()
        },
        fetch()
        {
            this.$store.dispatch('clientsFetch')
            this.$store.dispatch(this.action.fetch, this.slug).then(res => {
                this.item = res
            })
        },
        saveName()
        {
            this.save()
            this.isChange = false
        },
        save()
        {
            this.$store.dispatch(this.action.update, {name: this.item.name, id : this.item.id}).then( res => {
                this.item = res
                this.validation()
            })
        },
        saveAll()
        {
            this.$store.dispatch(this.action.update, this.item).then( res => {
            })
        },
        validation()
        {
            if (this.isCreativeValid) 
            {
                this.menu[0].done = true
            } else {
                this.menu[0].done = false
            }
            if (this.isSettingsValid) 
            {
                this.menu[1].done = true
            } else {
                this.menu[1].done = false
            }
            if (this.isCreativeValid && this.isSettingsValid) 
            {
                this.item.is_valid = true
                this.setValid()
            } else {
                if (this.item)
                    this.item.is_valid = false
            }
        },
        setValid()
        {
            this.$store.dispatch(this.action.update, Object.assign({}, this.item, { is_valid: true }))
        },
        selectClient(value)
        {
            this.item.client = value
            this.item.client_id = value.id
            this.saveAll()
            this.changeClient = false
        },
    },
    data()
    {
        return {
            item: null,
            menu: [
                {
                    name:'Creative',
                    slug:'creative',
                    done: false,
                },
                {
                    name:'Settings',
                    slug:'settings',
                    done: false,
                },
            ],
            slug: null,
            isChange: false,
            page:null,
            changeClient: false
        }
    },
    beforeRouteLeave(to, from, next) 
    {
        if (this.dirty)
        {
            this.$store.dispatch(this.action.redirect, to)
            this.$refs.confirmModal.openModal()
            next(false)
        } else {
            this.$store.dispatch(this.action.redirect, null)
            next()
        }
    },
    beforeRouteUpdate (to, from, next) 
    {
        if (this.dirty)
        {
            this.$store.dispatch(this.action.redirect, to)
            this.$refs.confirmModal.openModal()
            next(false)
        } else {
            this.$store.dispatch(this.action.redirect, null)
            next()
        }
    },
}



// WEBPACK FOOTER //
// ./src/mixins/edit/ItemEdit.js